import * as React from 'react';
import SubmitButton from '../../FormElements/SubmitButton';
import { useSzamlazzHuPanel } from './useSzamlazzHuPanel';

export const SzamlazzHuPanel = () => {
  const { token, onSubmit } = useSzamlazzHuPanel();
  return (
    <div>
      <div className="row text-center">
        <h2>Számlázz.hu azonosító kulcs</h2>
      </div>
      <p className="text-success text-center">
        Ez a legbonyolultabb lépés, de minden rendben lesz, menni fog!
        <br />
        Ha elakadsz, nyugodtan hívd az ügyfélszolgálatunkat ezen a számon: +36-1-850-6006
      </p>
      <div>
        A lenti sárga mezőben látható Számlázz.hu azonosító kulcsot kérjük, hogy másold be a céged Számlázz.hu fiókjába.
        Ennek a lépései az alábbiak:
        <ol>
          <li>
            Lépj be annak a cégednek a{' '}
            <a href="https://www.szamlazz.hu/szamla/login" target="_blank" rel="noreferrer">
              Számlázz.hu fiókjába <i className="bi-box-arrow-up-right"></i>
            </a>
            , aminek a bankszámla forgalmát elérhetővé szeretnéd tenni a pénzügyesed vagy könyvelőd számára.
          </li>
          <li>
            Ellenőrizd, hogy{' '}
            <a href="https://www.szamlazz.hu/szamla/?page=beallitasok-autokassza" target="_blank" rel="noreferrer">
              be van-e kapcsolva az autokassza <i className="bi-box-arrow-up-right"></i>
            </a>{' '}
            a Számlázz.hu fiókodban! Ha még nincs, akkor először azt kapcsold be.
          </li>
          <li>Jobb felül a [Beállítások] legördülő menüben válaszd ki a [Fiók beállításai] menüpontot.</li>
          <li>
            Ezen belül lent, a bal oldali menüben kattints a [
            <a
              href="https://www.szamlazz.hu/szamla/?page=beallitasok-konyveloiadatkapcsolat"
              target="_blank"
              rel="noreferrer"
            >
              Könyvelői adatkapcsolatok <i className="bi-box-arrow-up-right"></i>
            </a>
            ] menüpontra.
          </li>
          <li>
            Itt az [Új adatkapcsolat beállítása] alatt a [Fogadó rendszer]-nél válaszd ki az [Adriana (automatik.hu)]
            opciót.
          </li>
          <li>
            Alatta az [Azonosító kulcs] mező értéke ha üres, akkor másold be oda a Számlázz.hu azonosító kulcs értéket,
            amit ezen az oldalon lent találsz.
          </li>
          <ul>
            <li>
              Ha az [Azonosító kulcs] mező értéke már ki van töltve, akkor hagyd meg a régi kulcsot, és hívd fel az
              ügyfélszolgálatunkat.
            </li>
          </ul>
          <li>
            A [Számlák küldésének időszaka] értékeket, ha üresek, akkor mindkettőt állítsd be 2022.12.31-re, mert
            számlákat még nem szeretnénk átküldeni.
          </li>
          <ul>
            <li>
              A [Számlák küldésének időszaka] értékeket, ha már ki vannak töltve, akkor hagyd úgy, ahogy most vannak.
            </li>
          </ul>
          <li>
            A [Banki tranzakciók küldése] cím alatt a [Küldd át a banki tranzakciókat is] melletti pipát kattintsd be.
          </li>
          <li>
            A [Tranzakciók küldésének kezdete] értéket javasoljuk, hogy egy olyan napra állítsd be, amelyik napnak a
            teljes napi forgalma már benne van a Számlázz.hu-ban.
          </li>
          <ul>
            <li>
              Tehát például, ha ma napközben állítottad be a Számlázz.hu-ban az autokassza kapcsolatot a bankkal, akkor
              itt holnapi dátumot adj meg.
            </li>
          </ul>
          <li>
            A [Tranzakciók küldésének vége] érték maradjon üres. Ezt majd akkor kell csak beírnod, amikor meg akarod
            szüntetni a banki adatok átadását.
          </li>
        </ol>
      </div>
      <div className="row justify-content-center">
        <div className="col-10 col-lg-8 text-break text-center bg-warning rounded-3 p-3" data-testid="szamlazzhuToken">
          <strong>
            Számlázz.hu azonosító kulcs (a végén az "-atmtk" beletartozik):
            <br />
            {token}-atmtk
          </strong>
        </div>
      </div>
      <div className="row justify-content-center text-center">
        <div className="col mt-3">
          <p className="text-danger">
            <strong>
              FONTOS! Csak akkor nyomd meg ezt a [Rendben] gombot, ha már beállítottad a Számlázz.hu fiókodban a
              fentieket.
              <br />
              Miután ezt a [Rendben] gombot megnyomod, már nem tudsz visszajönni erre az oldalra, és az egészet előről
              kell kezdened.
            </strong>
          </p>
        </div>
      </div>
      <div className="row justify-content-center text-center">
        <div className="col-10 col-lg-8">
          <form onSubmit={onSubmit}>
            <input name="apiKey" id="apiKey" hidden readOnly value={token} />
            <SubmitButton
              className={'btn btn-primary'}
              dataTestId="szamlazzhuSubmit"
              text={'Rendben'}
              inProgress={false}
              disabled={false}
            />
          </form>
        </div>
      </div>
    </div>
  );
};
